var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-layout-mask',{key:_vm.$i18n.locale},[_c('m-scrollbar',[_c('iframe',{attrs:{"src":_vm.url,"data-anchor":"","scrolling":"no","width":"100%","height":"100%","frameborder":"0","allowfullscreen":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54b4363d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kazino/Kazino.vue
// module id = null
// module chunks = 